import { useEffect, useState } from "react"
import { DefaultLineItemGrouping } from "../../../domain/invoicing/settings/invoicingSettings"
import useServiceTicketsEnabled from '../../../hooks/useServiceTicketsEnabled'
import VSpace from "../../common/VSpace"
import SettingsCard from "../SettingsCard"
import JobTypeLineItemGroupingCard from "./JobTypeLineItemGroupingCard"
import { areLineItemGroupingSettingsUpdated } from "./invoicingSettingsModel"
import { useUpdateDefaultLineItemGroupingMutation } from "../../../domain/invoicing/settings/invoicingSettingsQueries"

type Props = {
  serverSettings: DefaultLineItemGrouping
}

const JobTypeSettingsCard = ({ serverSettings }: Props) => {
  const showServiceTickets = useServiceTicketsEnabled()
  const [settings, setSettings] = useState<DefaultLineItemGrouping>(serverSettings)
  const isUpdateDisabled = !areLineItemGroupingSettingsUpdated(settings, serverSettings)
  const mutation = useUpdateDefaultLineItemGroupingMutation()

  useEffect(() => {
    setSettings(serverSettings)
  }, [serverSettings])

  return <SettingsCard
    title="Job Type Settings"
    description="Manage job types and their default settings."
    onUpdate={() => mutation.mutate(settings)}
    isUpdating={mutation.isLoading}
    updateDisabled={isUpdateDisabled || mutation.isLoading}
  >
    <VSpace>
      <JobTypeLineItemGroupingCard jobTypeName="Project" option={settings.project} onChange={project => setSettings({...settings, project})} />
      <JobTypeLineItemGroupingCard jobTypeName="Maintenance" option={settings.maintenance} onChange={maintenance => setSettings({...settings, maintenance})} />
      {showServiceTickets && <JobTypeLineItemGroupingCard jobTypeName="Service Ticket" option={settings.serviceTicket} onChange={serviceTicket => setSettings({...settings, serviceTicket})} />}
    </VSpace>
  </SettingsCard>
}

export default JobTypeSettingsCard
